import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Badge, Button, ButtonGroup, Card, CardBody, Col, Row } from 'reactstrap';

import FontAwesome from 'react-fontawesome';
import classNames from 'classnames';
import { getContentBlockItemByName, getContentBlockItemsByName, getContentBlockMixedItem, getContentBlockMixedItems } from '../../../../Cms/CmsActions';
import HtmlComponent from '../../../../../components/Text/HtmlComponent';
import CmsBlockItem from '../../../../Cms/components/content/CmsBlockItem';
import Slider from '../../../../../components/Content/Slider';

function ConversationImportTutorial({ panel }) {
	const [stepIndex, setStepIndex] = useState(0);
	const [variationIdentifier, setVariationIdentifier] = useState(null);
	const [activeTutorialStep, setActiveTutorialStep] = useState(0);

	const steps = [];

    const intro = getContentBlockItemByName(panel.blocks, 'introduction');
	const introText = getContentBlockMixedItem(intro, 'text') && <HtmlComponent text={getContentBlockMixedItem(intro, 'text').text} />;
	const introImage = getContentBlockMixedItem(intro, 'image') && <CmsBlockItem type="image" item={getContentBlockMixedItem(intro, 'image')} className="w-100 rounded-5" />;
	if(intro && introText) {
		steps.push('introduction');
	}
	// console.log(intro, introText, introImage);

    const selection = getContentBlockItemByName(panel.blocks, 'selection');
	const selectionText = getContentBlockMixedItem(selection, 'text') && <HtmlComponent text={getContentBlockMixedItem(selection, 'text').text} />;
	const selectionLinks = getContentBlockMixedItems(selection, 'links');
	if(selection && selectionText && selectionLinks.length) {
		steps.push('selection');
	}
	// console.log(selection, selectionText, selectionLinks);

	steps.push('steps');

	const goToNextStep = () => setStepIndex(previousStep => {
		if(steps[previousStep + 1]) {
			return previousStep + 1;
		}
		return previousStep;
	});
	const goToPreviousStep = () => setStepIndex(previousStep => previousStep - 1);

	const renderIntro = () => {
		return (
			<Row>
				<Col className={classNames(!introImage && 'text-center', 'p-2')}>
					{introText}
					<Button color="dark" className="rounded-pill" onClick={goToNextStep}><FormattedMessage id="conversationImportTutorialGoNext" defaultMessage="See more" /> <FontAwesome name="chevron-right" /></Button>
				</Col>
				{introImage && (
					<Col xs={{ size: 12, order: 0 }} md={{ size: 6, order: 1 }} className="text-center">
						{introImage}
					</Col>
				)}
			</Row>
		);
	};

	const renderSelection = () => {
		return (
			<div className="text-center">
				{selectionText}
				<div className="d-flex justify-content-center">
					{selectionLinks.map(selectionLink => {
						const link = getContentBlockMixedItem(selectionLink, 'variation-link');
						return (
							<Button key={link.path} color="dark" className="rounded-pill me-1" onClick={() => { setVariationIdentifier(link.path); goToNextStep(); }}>{link.text}</Button>
						);
					})}
				</div>
			</div>
		);
	};

	const renderSteps = () => {
		const variations = getContentBlockItemsByName(panel.blocks, 'variations');
		const variation = variationIdentifier ? variations.find(variation => getContentBlockMixedItem(variation, 'identifier').text === variationIdentifier) : variations[0];
		const variationSteps = getContentBlockMixedItems(variation, 'steps');
		// console.log(variationIdentifier, variations, variation, variationSteps);
		if(variationSteps?.length) {
			return (
				<Slider
					slides={(variationSteps || []).map(variationStep => {
						const stepText = getContentBlockMixedItem(variationStep, 'text') && <HtmlComponent text={getContentBlockMixedItem(variationStep, 'text').text} />;
						const stepImage = getContentBlockMixedItem(variationStep, 'image') && <CmsBlockItem type="image" item={getContentBlockMixedItem(variationStep, 'image')} className="w-100 rounded-5" />;
						return {
							content: (
								<Fragment>
									<Row>
										<Col xs={{ size: 12, order: 1 }} md={{ size: 6, order: 0 }}>
											{stepText}
										</Col>
										<Col className="text-center">
											{stepImage || 'no image'}
										</Col>
									</Row>
									<ButtonGroup className="d-block my-2 text-center">
										{activeTutorialStep > 0 && <Button className="rounded-pill mx-1" onClick={() => setActiveTutorialStep(prev => prev - 1)}><FontAwesome name="chevron-left" /></Button>}
										{activeTutorialStep < (variationSteps.length - 1) && <Button className="rounded-pill mx-1" onClick={() => setActiveTutorialStep(prev => prev + 1)}><FontAwesome name="chevron-right" /></Button>}
									</ButtonGroup>
								</Fragment>
							),
						};
					})}
					disableControls
					disableLightbox
					activeSlider={activeTutorialStep}
					interval={9999999}
				/>
			);
		}
		return 'go next';
	};

	const renderStep = () => {
		const step = steps[stepIndex];
		switch(step) {
			case 'introduction':
				return renderIntro();

			case 'selection':
				return renderSelection();

			case 'steps':
				return renderSteps();

			default:
				setStepIndex(0);
				return 'no more step!';
		}
	};

	return (
		<Card className="border-0">
			<CardBody>
				{stepIndex > 0 && <Button color="link" size="sm" onClick={() => setStepIndex(prev => prev - 1)}><FontAwesome name="chevron-left" /></Button>}
				<Badge pill color="light"><FormattedMessage id="conversationImportTutorialStep" defaultMessage="Step {step}" values={{ step: stepIndex + activeTutorialStep + 1 }} /></Badge>
				{renderStep()}
				{/* {process.env.NODE_ENV === 'development' && <Button onClick={goToPreviousStep}>Previous step</Button>} */}
   </CardBody>
		</Card>
	);
}

ConversationImportTutorial.propTypes = {
	panel: PropTypes.object.isRequired,
};

export default ConversationImportTutorial;
